function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_39884",
  "data-name": "Group 39884",
  transform: "translate(-559.07 -320.319)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_676",
  "data-name": "Rectangle 676",
  width: 15,
  height: 20,
  transform: "translate(559.57 320.819)",
  fill: "none",
  stroke: "#a8a8a8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_677",
  "data-name": "Rectangle 677",
  width: 11.551,
  height: 4.52,
  transform: "translate(561.294 322.589)",
  fill: "none",
  stroke: "#a8a8a8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_678",
  "data-name": "Rectangle 678",
  width: 5.045,
  height: 3.929,
  transform: "translate(561.294 329.404)",
  fill: "none",
  stroke: "#a8a8a8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_679",
  "data-name": "Rectangle 679",
  width: 5.045,
  height: 3.929,
  transform: "translate(567.801 329.404)",
  fill: "none",
  stroke: "#a8a8a8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_680",
  "data-name": "Rectangle 680",
  width: 5.045,
  height: 3.929,
  transform: "translate(561.294 335.111)",
  fill: "none",
  stroke: "#a8a8a8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_681",
  "data-name": "Rectangle 681",
  width: 5.045,
  height: 3.929,
  transform: "translate(567.801 335.111)",
  fill: "none",
  stroke: "#a8a8a8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}));

var SvgJoratoCalc = function SvgJoratoCalc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoCalc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-calc.1b8e4ec7.svg";
export { ForwardRef as ReactComponent };